import React, { useState } from "react";
import IconeV2 from "./IconeV2";

// ===================================================================
// The Crowd v2 — Bibliotheques : arborescence
//
// Deux modes, comme dans l'interface actuelle :
//  - dossiers du Blob (fermes par defaut), avec renommage et
//    suppression de dossier pour les droits complets ;
//  - regroupement par front matter (ex : Cybervadis, fonction ->
//    critere -> fiches).
// Aucun appel API : la page fournit l'arbre et les actions.
// ===================================================================

function indentation(depth) {
  return { paddingLeft: `${depth * 14 + 10}px` };
}

function LigneFichier({ libelle, actif, depth, onClick }) {
  return (
    <button
      type="button"
      className={`v2-arbo-fichier${actif ? " actif" : ""}`}
      style={indentation(depth)}
      aria-current={actif ? "true" : undefined}
      onClick={onClick}
      title={libelle}
    >
      <IconeV2 nom="fichier" taille={13} />
      <span className="v2-arbo-libelle">{libelle}</span>
    </button>
  );
}

function Dossier({ libelle, depth, children, actions }) {
  const [ouvert, setOuvert] = useState(false);
  return (
    <div>
      <div className="v2-arbo-dossier-ligne">
        <button
          type="button"
          className="v2-arbo-dossier"
          style={indentation(depth)}
          aria-expanded={ouvert}
          onClick={() => setOuvert((o) => !o)}
          title={libelle}
        >
          <IconeV2 nom={ouvert ? "chevronBas" : "chevronDroite"} taille={12} className="v2-arbo-chevron" />
          <IconeV2 nom={ouvert ? "dossierOuvert" : "dossier"} taille={14} />
          <span className="v2-arbo-libelle">{libelle}</span>
        </button>
        {actions}
      </div>
      {ouvert && children}
    </div>
  );
}

// --- Mode dossiers ---

function NoeudDossiers({ node, depth, parentPath, selectedPath, onSelectFile, canEdit, onRenameDossier, onDeleteDossier }) {
  if (node.type === "directory") {
    const chemin = parentPath ? `${parentPath}/${node.name}` : node.name;
    const actions = canEdit ? (
      <span className="v2-arbo-actions">
        <button type="button" className="v2-arbo-action" onClick={() => onRenameDossier(chemin, node.name)} aria-label={`Renommer le dossier ${node.name}`} title="Renommer le dossier">
          <IconeV2 nom="crayon" taille={12} />
        </button>
        <button type="button" className="v2-arbo-action" onClick={() => onDeleteDossier(chemin, node.name)} aria-label={`Supprimer le dossier ${node.name}`} title="Supprimer le dossier">
          <IconeV2 nom="corbeille" taille={12} />
        </button>
      </span>
    ) : null;

    return (
      <Dossier libelle={node.name} depth={depth} actions={actions}>
        {node.children &&
          node.children.map((child) => (
            <NoeudDossiers
              key={child.path || child.name}
              node={child}
              depth={depth + 1}
              parentPath={chemin}
              selectedPath={selectedPath}
              onSelectFile={onSelectFile}
              canEdit={canEdit}
              onRenameDossier={onRenameDossier}
              onDeleteDossier={onDeleteDossier}
            />
          ))}
      </Dossier>
    );
  }

  const visible = node.name.endsWith(".md") || node.name.endsWith(".html");
  if (!visible) return null;
  return (
    <LigneFichier
      libelle={node.name}
      actif={selectedPath === node.path}
      depth={depth}
      onClick={() => onSelectFile(node.path, node.name)}
    />
  );
}

export function ArborescenceDossiers({ tree, selectedPath, onSelectFile, canEdit, onRenameDossier, onDeleteDossier }) {
  if (!tree) return null;
  return (
    <div className="v2-arbo">
      {tree.map((node) => (
        <NoeudDossiers
          key={node.path || node.name}
          node={node}
          depth={0}
          parentPath=""
          selectedPath={selectedPath}
          onSelectFile={onSelectFile}
          canEdit={canEdit}
          onRenameDossier={onRenameDossier}
          onDeleteDossier={onDeleteDossier}
        />
      ))}
    </div>
  );
}

// --- Mode regroupement par front matter ---

export function ArborescenceGroupee({ groupes, selectedPath, onSelectFile }) {
  if (!groupes) return null;
  return (
    <div className="v2-arbo">
      {Object.entries(groupes).map(([fonction, criteres]) => (
        <Dossier key={fonction} libelle={fonction} depth={0}>
          {Object.entries(criteres).map(([critere, fiches]) => (
            <Dossier key={critere} libelle={critere} depth={1}>
              {fiches.map((fiche) => (
                <LigneFichier
                  key={fiche.blobPath}
                  libelle={fiche.titre || fiche.name.replace(/\.md$/i, "").replace(/_/g, " ")}
                  actif={selectedPath === fiche.blobPath}
                  depth={2}
                  onClick={() => onSelectFile(fiche.blobPath, fiche.name)}
                />
              ))}
            </Dossier>
          ))}
        </Dossier>
      ))}
    </div>
  );
}
